import styled from 'styled-components'

import { MEDIA_QUERY_HP_LARGE_DESKTOP } from '@/components/homepage/styled'
import { Flex } from '@/ui/atoms/flex'

export const PopularListingsWrapper = styled.div(
  ({ theme }) => `
  margin-top: ${theme.spacing.husky};
`
)

export const PopularListingsHeaderWrapper = styled(Flex)(
  ({ theme }) => `
  padding: 0 ${theme.spacing.default};
  width: 100%;
  
  ${MEDIA_QUERY_HP_LARGE_DESKTOP} {
    padding: 0;
  }
`
)
